export default {
  title: 'Тестовый период завершен',
  body: 'Если хотите продолжить пользоваться платными функциями, нажмите кнопку «Запросить тариф».',
  ok: 'Запросить тариф',
  cancel: 'Отмена'
}
